import { render, staticRenderFns } from "./GoldsmithItemEditForm.vue?vue&type=template&id=1582f040"
import script from "./GoldsmithItemEditForm.vue?vue&type=script&lang=js"
export * from "./GoldsmithItemEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports